//

import { SelectProps } from 'antd';
import { IFormFieldSchema } from '../../types';
import { DefaultOptionType } from 'antd/es/select';

export interface ISelectOption {
  label: string;
  value: string | number;
  disabled: boolean;
  children: ISelectOption[];
}

const DEFAULT_OPTIONS: ISelectOption[] = [
  { label: 'Option 1', value: '1', disabled: false, children: [] },
  { label: 'Option 2', value: '2', disabled: false, children: [] },
];

// prefer enum as source of truth, fallback to options, then default
// ensure the result is always an array
export const generateOptions = (
  props:
    | Partial<IFormFieldSchema<SelectProps<any, DefaultOptionType>>>
    | undefined
) => {
  const rawOptions = props?.enum || props?.['x-component-props']?.options;
  let options: ISelectOption[];

  if (Array.isArray(rawOptions)) {
    options = rawOptions.map(opt => {
      if (
        typeof opt === 'object' &&
        opt !== null &&
        'label' in opt &&
        'value' in opt
      ) {
        return {
          label: String(opt.label),
          value: opt.value,
          disabled: (opt as any)?.disabled,
          children: (opt as any)?.children,
        };
      }
      return {
        label: String(opt),
        value: opt,
        disabled: false,
        children: [],
      };
    });
  } else {
    options = DEFAULT_OPTIONS;
  }

  return options;
};
